import { Strings } from "@app/constants"
import { Stack, Typography } from "@mui/material"

const Philosophy = () =>{
    return (
        <Stack sx={{
            px:{xs:4,md:15},
            pt:3,
            pb:5,
            boxShadow:"2px 2px 10px #0000005d",
            borderRadius: 2,
        }}>
            <Typography variant="h3" textAlign={"center"} sx={{
                mb:3,
                fontSize:32
            }}>
            {Strings.landingPage.philosophy}
            </Typography>
            <Typography textAlign={"center"} variant="body2">
                {Strings.landingPage.ourPhilosophyEncompasses}
            </Typography>
            <Typography textAlign="center" variant="body2">
  Our founder’s values have now evolved over the years under the management of{" "}
  <b>Mrs. Jyothi M</b> - Dealer Principal & <b>Mr. Mahesh Kumar M</b> – CEO, and the remarkable KAIZEN MOTOR family. We pledge to listen to our customers’ demands and meet all their needs while constantly innovating to remain market leaders in the industry.
</Typography>

            <Typography textAlign={"center"} variant="body2">
                {Strings.landingPage.KAIZENMOTORPractices}
            </Typography>
            <Typography textAlign={"center"} variant="body2">
                {Strings.landingPage.KAIZENMOTORHasRecognised}
            </Typography>
        </Stack>
    )
}

export {Philosophy};